import { Component, inject, output, signal, viewChild } from '@angular/core';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { FieldValueReplacementService } from '../field-value-replacement.service';
import { ActionEventArgs, GridComponent, RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { TranslateModule } from '@ngx-translate/core';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { ClientAutocompleteComponent } from '../../../../base/shared/client-autocomplete/client-autocomplete.component';

@Component({
    selector: 'app-field-value-replacements-client-selector',
    templateUrl: './field-value-replacements-client-selector.component.html',
    styleUrls: ['./field-value-replacements-client-selector.component.scss'],
    imports: [ClientAutocompleteComponent, GridModule, QueryBuilderModule, TranslateModule]
})
export class FieldValueReplacementsClientSelectorComponent {
  private readonly fieldValueReplacementService = inject(FieldValueReplacementService);

  public readonly selectedClientChange = output<ClientDTO>();

  private readonly clientGrid = viewChild.required<GridComponent>('clientGrid');

  public readonly clientsHavingReplacements = signal<ClientDTO[]>([]);

  private readonly _selectedClient = signal<ClientDTO | null>(null);

  public get selectedClient(): ClientDTO | null {
    return this._selectedClient();
  }

  public set selectedClient(value: ClientDTO | null) {
    if (this._selectedClient() !== value) {
      this._selectedClient.set(value);
      if (value) {
        this.addClientToGrid();
      }
    }
  }

  constructor() {
    this.clientsHavingReplacements.set([...this.fieldValueReplacementService.clientsHavingReplacements]);
  }

  public addClientToGrid() {
    const client = this._selectedClient();
    if (!client) return;
    if (this.clientsHavingReplacements().find(c => c.id == client.id)) {
      setTimeout(() => this._selectedClient.set(null), 0);
      return;
    }
    const newList = [...this.clientsHavingReplacements(), client];
    newList.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    this.clientsHavingReplacements.set(newList);
    this.clientGrid().refresh();
  }

  public onGridClientSelected(args: RowSelectEventArgs): void {
    this.selectedClientChange.emit(args.data as ClientDTO);
  }

  public onActionComplete(args: ActionEventArgs) {
    if (args.requestType === 'refresh') {
      const client = this._selectedClient();
      const clientIndex = this.clientsHavingReplacements().findIndex(c => c.id == client?.id);
      this._selectedClient.set(null);
      this.clientGrid().selectRow(clientIndex);
    }
  }

  public reset() {
    this.fieldValueReplacementService.getFieldValueReplacementClients().subscribe((result: ClientDTO[]) => {
      this.clientsHavingReplacements.set(result);
    });
  }
}
